var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEbusinessDiversion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-diversion_svg__a",
    d: "M2.5 6.2H3c.2 0 .3.1.3.3v5.1c0 .2-.1.3-.3.3h-.5c-.2 0-.3-.1-.3-.3V6.5c0-.1.1-.3.3-.3zm5.9.2v-.5c0-.5.6-.7.9-.4l3.1 2.9c.3.3.4.8.1 1.2l-.1.1-3.1 2.9c-.4.3-.9.1-.9-.4v-.6h-4c-.3 0-.6-.3-.6-.6V7c0-.3.3-.6.6-.6h4zm.5 1.2H5v2.8h3.9c.3 0 .5.2.5.4l2-1.8-2-1.8c0 .2-.2.4-.5.4zM5.8 5.4h-.5c-.2 0-.3-.1-.3-.3V4c0-1 .7-1.7 1.7-1.7H14c.9 0 1.7.8 1.7 1.7v10.1c0 .9-.8 1.7-1.7 1.7H6.7c-1 0-1.7-.8-1.7-1.7v-1.4c0-.2.1-.3.3-.3h.6c.2 0 .3.1.3.3v1.4c0 .3.3.6.6.6H14c.3 0 .6-.3.6-.6V4c0-.3-.3-.6-.6-.6H6.7c-.3 0-.6.3-.6.6v1.1c0 .2-.1.3-.3.3z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-diversion_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-diversion_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ebusiness-diversion_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-diversion_svg__c",
    d: "M-450.1-1678h1424V316h-1424z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-diversion_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-diversion_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ebusiness-diversion_svg__d)",
    d: "M-2.8-2.7h23.5v23.5H-2.8z"
  }))));
}

export default SvgEbusinessDiversion;